import React from 'react';
import Navbar from '../Layout/Navbar';
import PublicNavbar from '../Layout/PublicNavbar';
import Footer from '../Layout/Footer';
import { useAuth } from '../../contexts/AuthContext';
import SEO from '../Common/SEO';
import './Legal.css';

function TermsOfService() {
  const { isAuthenticated } = useAuth();
  const updatedDate = 'January 16, 2026';

  return (
    <div className="page-wrapper">
      <SEO
        title="Terms of Service"
        description="Options Tracker Terms of Service - Read our terms and conditions for using the options trading tracker platform."
        canonicalPath="/terms"
      />
      {isAuthenticated ? <Navbar /> : <PublicNavbar />}
      <div className="container legal-page">
        <div className="page-header">
          <div>
            <h1>Terms of Service</h1>
            <p className="page-subtitle">Please read these terms carefully before using Options Tracker.</p>
            <div className="legal-updated">Last updated: {updatedDate}</div>
          </div>
        </div>

        <h2>Acceptance of Terms</h2>
        <p>
          By accessing or using Options Tracker, you agree to be bound by these Terms of Service. If you do not agree,
          do not use the service.
        </p>

        <h2>Service Description</h2>
        <p>
          Options Tracker is a portfolio tracking and analytics tool designed for educational and record-keeping
          purposes. It is not a broker, financial advisor, or trading platform.
        </p>

        <h2>No Financial Advice</h2>
        <p>
          The content, calculations, and metrics provided by Options Tracker are for educational and informational
          purposes only and do not constitute financial advice. You are solely responsible for your trading decisions.
        </p>

        <h2>Market Data Disclaimer</h2>
        <p>
          Market data and index values may be delayed, approximated, or sourced from third parties. VIX values in
          particular may be estimated and may not be precise. Do not rely on the service for real-time trading decisions.
        </p>

        <h2>Accounts and Security</h2>
        <p>
          You are responsible for maintaining the confidentiality of your account credentials. Notify us immediately if
          you suspect unauthorized access.
        </p>

        <h2>Free and Pro Plans</h2>
        <p>
          Options Tracker offers a free plan with usage limits and a paid Pro plan for unlimited access.
          Plan features and limits are subject to change. Pro subscriptions renew according
          to the terms displayed at checkout. You may cancel your subscription as described in the app.
        </p>

        <h2>Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Options Tracker and its operators are not liable for any losses,
          damages, or trading decisions arising from your use of the service.
        </p>

        <h2>Changes to Terms</h2>
        <p>
          We may update these Terms of Service from time to time. Continued use of the service constitutes acceptance
          of the revised terms.
        </p>

        <h2>Contact</h2>
        <p>
          If you have questions about these terms, contact support at
          {' '}
          <a href="mailto:options.tracker.email.verify@gmail.com?subject=Terms%20of%20Service">
            options.tracker.email.verify@gmail.com
          </a>
          .
        </p>
      </div>
      <Footer />
    </div>
  );
}

export default TermsOfService;

